<template>
	<div class='ListOfPersons' v-if='listOfPeopels.length'>
		<Person v-for='(person, p) in listOfPeopels' :key='p' :person='person' />
	</div>
</template>

<script>
import Person from './components/Person/Person.vue';
export default {
	name:  'ListOfPersons',
	props: {
		listOfPeopels: {
			type:    Array,
			default: () => []
		}
	},
	components: {
		Person
	}
};
</script>
